export default {
      id: "icon-bulle-de-discussion-usage",
      viewBox: "0 0 99.4 99.4",
      url: __webpack_public_path__ + "icons.svg#icon-bulle-de-discussion",
      toString: function () {
        return this.url;
      }
    }